import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { LoadingSpinner } from '@opengov/component-library/capital';

import { IModalMessages } from '../../../types';

import { styles } from './PdfLoading.styles';

export type IPdfLoadingProps = {
  open: boolean;
  messages: IModalMessages;
  isExporting: boolean;
  isExportingFailure: boolean;
  onClose(): void;
};

export const PdfLoading: React.FC<IPdfLoadingProps> = ({ open, messages, isExporting, isExportingFailure, onClose }) => {
  const title = isExportingFailure ? messages.pdfExportFailure : messages.pdfExport;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: styles.dialogPaper }} aria-labelledby="pdf-loading-dialog-title">
      <DialogTitle id="pdf-loading-dialog-title" sx={styles.dialogTitle}>
        {title}
        <IconButton aria-label="close" onClick={onClose} size="small" sx={styles.closeButton}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        {isExportingFailure ? (
          <>
            <Box sx={styles.centeredContent}>
              <ErrorOutlineIcon sx={styles.failureIcon} aria-hidden="true" />
            </Box>
            <Typography variant="body2">{messages.pdfExportFailureText}</Typography>
          </>
        ) : (
          <>
            {isExporting && <Typography variant="body2">{messages.pdfExportText}</Typography>}
            {isExporting && (
              <Box sx={styles.centeredContent} data-test="story-exporting-pdf">
                <LoadingSpinner variant="page" />
              </Box>
            )}
            {!isExporting && (
              <Box sx={styles.centeredContent} data-test="story-exported-pdf">
                <CheckCircleOutlineIcon sx={styles.successIcon} aria-hidden="true" />
              </Box>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button variant="contained" color="primary" size="small" onClick={onClose}>
          {messages.done}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
